<template>
  <div class="scenery">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../assets/images/dongguologo.jpg"
    />
    <div class="tit">
      <!-- <h3>校园风景</h3> -->
      <img src="../../assets/images/校园风景.png" alt="" />
    </div>
    <ul class="imgList">
      <li v-for="(item, index) in listArr" :key="index">
        <img v-lazy="imgUrl + item.Extend1" />
        <p>{{ item.InfoUrl }}</p>
      </li>
    </ul>
    <a href="javascript:;" class="more" @click="LoadMore">{{ moreTxt }}</a>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from "vue";
import { Lazyload } from "vant";
export default {
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: "keywords",
          content: "东国大学风景,东国大学校园,东国大学图片",
        },
        {
          name: "description",
          content:
            "韩国东国大学有4个校区,首尔校区位于韩国首尔市南山公园森林附近,本页面带您领略不一样的校园风景.",
        },
      ],
    };
  },
  name: "scenery",
  data() {
    return {
      title: "校园风景-东国概况-韩国东国大学中文官网",
      listArr: [],
      imgUrl: "",
      moreTxt: "点击加载更多",
      pagination: {
        // 总条数
        total: 0,
        // 当前页码
        currentPage: 1,
        // 默认多少条数
        pagesize: 6,
      },
      isLoad: true,
    };
  },
  components: {},
  mounted() {
    this.getDate();
  },
  created() {
    this.$emit("handleTKD", "东国概况");
  },
  methods: {
    LoadMore() {
      if (!this.isLoad) return false;
      this.getDate();
    },
    getDate() {
      this.moreTxt = "加载中...";
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          WebsiteMenuId: 412,
          index: this.pagination.currentPage,
          size: this.pagination.pagesize,
        })
        .then((res) => {
          this.listArr = this.listArr.concat(res.data.Data.list);
          this.moreTxt = "点击加载更多";
          if (this.listArr.length >= res.data.DataCount) {
            this.isLoad = false;
            this.moreTxt = "没有更多了";
          }
        });
      this.pagination.currentPage++;
    },
  },
};
</script>

<style lang="scss" scoped>
.scenery {
  margin-top: 134px;
  padding-top: 60px;
  .tit {
    width: 157px;
    height: 40px;
    margin: auto;
    margin-bottom: 40px;
    img {
      width: 157px;
      height: 40px;
      margin: auto;
    }
  }
  .imgList {
    display: flex;
    padding: 0 30px;
    flex-wrap: wrap;
    justify-content: space-around;
    li {
      width: 330px;
      margin-bottom: 40px;
      img {
        display: block;
        max-width: 100%;
        width: 320px;
        height: 185px;
        object-fit: cover;
      }
      p {
        margin-top: 30px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        // line-height: 36px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
    &:after {
      content: "";
      border: 1px solid transparent;
      width: 320px;
    }
  }
  .more {
    display: block;
    font-size: 22px;
    color: #ffffff;
    background: #f48729;
    height: 60px;
    line-height: 60px;
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    width: calc(100% - 60px);
    text-decoration: none;
    border-radius: 8px;
    margin-bottom: 26px;
  }
}
</style>
